import html2canvas from "html2canvas";
import { AttemptId, ProductId } from "./index";

export abstract class MetadataDataSource<P extends ProductId, A extends AttemptId> {
	/** @returns {string} */
	abstract getProductId(): Promise<P>

	/** @returns {number} */
	abstract getAttempt(): Promise<A>

	/** @returns {Promise<string>} */
	getUrl(): Promise<string> { return new Promise(resolve => resolve(window.location.href)); }

	/**
	 * @returns {Promise<string>}
	 */
	getScreenshot(): Promise<string> {
		return typeof html2canvas==='undefined' ?
			new Promise(resolve => resolve('')):
			html2canvas(document.querySelector('body'))
				.then(canvas => canvas.toDataURL());
	}
}

export class NullMetadataDataSource<P extends ProductId, A extends AttemptId> extends MetadataDataSource<P, A> {
	getProductId(): Promise<P> { throw new Error("Method not implemented."); }

	getAttempt(): Promise<A> { throw new Error("Method not implemented."); }
}